import { AxiosError } from "axios";
import { createApi } from "../../../utils/createApi";
import { markSiteUnsynced } from "../../../utils/syncStore";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import ErrorBoundary from "../../../../ErrorBoundary";
import { NavigateFunction } from "react-router-dom";
import { AlertSettingsTab } from "../AlertSettingsTab";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";

export const handleDeleteImmixAlert = (
  immixAlertId: number,
  immixAlerts: any,
  setImmixAlerts: any,
  setActiveTab: any,
  setAddImmixAlertDialogOpen: any,
  setSendingImmixTest: Dispatcher<boolean>,
  setImmixTestSuccessDialogOpen: Dispatcher<boolean>,
  setImmixTestFailDialogOpen: Dispatcher<boolean>,
  setDeleteImmixAlertDialogOpen: Dispatcher<boolean>,
  setBackdropLoadingScreenOn: any,
  sureviewAlerts: any,
  setAddSureviewAlertDialogOpen: any,
  cameraWebhookData: any,
  setAddStreamWebhookDialogOpen: any,
  setEditStreamWebhookDialogOpen: any,
  sentinelAlerts: any,
  setAddSentinelAlertDialogOpen: any,
  boldAlerts: any,
  setAddBoldAlertDialogOpen: any,
  patriotAlerts: any,
  setAddPatriotAlertDialogOpen: any,
  softguardAlerts: any,
  setAddSoftguardAlertDialogOpen: any,
  immixAlertsOnCamera: any,
  sureViewAlertsOnCamera: any,
  siteInfo: any,
  webhooksAlertsOnCamera: any,
  sentinelAlertsOnCamera: any,
  boldAlertsOnCamera: any,
  patriotAlertsOnCamera: any,
  softguardAlertsOnCamera: any,
  evalinkAlertsOnCamera: boolean,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleDeleteImmixAlert(
      immixAlertId,
      immixAlerts,
      setImmixAlerts,
      setActiveTab,
      setAddImmixAlertDialogOpen,
      setSendingImmixTest,
      setImmixTestSuccessDialogOpen,
      setImmixTestFailDialogOpen,
      setDeleteImmixAlertDialogOpen,
      setBackdropLoadingScreenOn,
      sureviewAlerts,
      setAddSureviewAlertDialogOpen,
      cameraWebhookData,
      setAddStreamWebhookDialogOpen,
      setEditStreamWebhookDialogOpen,
      sentinelAlerts,
      setAddSentinelAlertDialogOpen,
      boldAlerts,
      setAddBoldAlertDialogOpen,
      patriotAlerts,
      setAddPatriotAlertDialogOpen,
      softguardAlerts,
      setAddSoftguardAlertDialogOpen,
      immixAlertsOnCamera,
      sureViewAlertsOnCamera,
      siteInfo,
      webhooksAlertsOnCamera,
      sentinelAlertsOnCamera,
      boldAlertsOnCamera,
      patriotAlertsOnCamera,
      softguardAlertsOnCamera,
      evalinkAlertsOnCamera,
      navigate
    );
  };

  const {
    cameraStreamsObject,
    setCameraStreamsPatchObject,
    setCameraStreamsObject,
    cameraStreamsSelectedIndex,
  } = useEditCameraStore.getState();

  AxiosUI.delete(`/immix/${immixAlertId}/`).then(
    () => {
      // Alert configs ride settings.json — deleting one needs a sync.
      markSiteUnsynced();
      // const updatedImmixAlerts = immixAlerts.filter(
      //   (alert: any) => Number(alert.id) !== Number(immixAlertId)
      // );

      const updatedStreams = cameraStreamsObject;

      if (
        updatedStreams[cameraStreamsSelectedIndex]?.immix_alerts &&
        cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts
      ) {
        updatedStreams[cameraStreamsSelectedIndex]!.immix_alerts =
          cameraStreamsObject[cameraStreamsSelectedIndex]!.immix_alerts!.filter(
            (alert: any) => Number(alert.id) !== Number(immixAlertId)
          );
      }

      setCameraStreamsPatchObject(updatedStreams);
      setCameraStreamsObject(updatedStreams);

      // setImmixAlerts(updatedImmixAlerts);
      setActiveTab(<></>);
      setActiveTab(
        <ErrorBoundary>
          <AlertSettingsTab
            immixAlerts={[]}
            setAddImmixAlertDialogOpen={setAddImmixAlertDialogOpen}
            setSendingImmixTest={setSendingImmixTest}
            setImmixTestSuccessDialogOpen={setImmixTestSuccessDialogOpen}
            setImmixTestFailDialogOpen={setImmixTestFailDialogOpen}
            setDeleteImmixAlertDialogOpen={setDeleteImmixAlertDialogOpen}
            sureviewAlerts={sureviewAlerts}
            setAddSureviewAlertDialogOpen={setAddSureviewAlertDialogOpen}
            setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
            setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
            sentinelAlerts={sentinelAlerts}
            setAddSentinelAlertDialogOpen={setAddSentinelAlertDialogOpen}
            boldAlerts={boldAlerts}
            setAddBoldAlertDialogOpen={setAddBoldAlertDialogOpen}
            patriotAlerts={patriotAlerts}
            setAddPatriotAlertDialogOpen={setAddPatriotAlertDialogOpen}
            softguardAlerts={softguardAlerts}
            setAddSoftguardAlertDialogOpen={setAddSoftguardAlertDialogOpen}
            immixAlertsOnCamera={immixAlertsOnCamera}
            sureViewAlertsOnCamera={sureViewAlertsOnCamera}
            siteInfo={siteInfo}
            webhooksAlertsOnCamera={webhooksAlertsOnCamera}
            sentinelAlertsOnCamera={sentinelAlertsOnCamera}
            boldAlertsOnCamera={boldAlertsOnCamera}
            patriotAlertsOnCamera={patriotAlertsOnCamera}
            softguardAlertsOnCamera={softguardAlertsOnCamera}
            evalinkAlertsOnCamera={evalinkAlertsOnCamera}
            navigate={navigate}
          />
        </ErrorBoundary>
      );
      setBackdropLoadingScreenOn(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        alert("Error deleting Immix Alert, please try again.");
        setBackdropLoadingScreenOn(false);
      });
    }
  );
};
